import type { ReactNode } from 'react';
import { bubbleSurface, formatDateSeparator } from './chatBubbleModel';

/** Day divider pill, identical to the employee chat. */
export function ChatDaySeparator({ date, t, lang }: { date: string; t: (k: string) => string; lang: string }) {
  return (
    <div className="flex justify-center my-3">
      <span className="text-xs text-surface-600 bg-surface-0 px-3 py-1 rounded-full border border-surface-200">
        {formatDateSeparator(date, t, lang)}
      </span>
    </div>
  );
}

/**
 * One chat bubble row (D-229): content-width bubble, own side vs other side,
 * sender name above, time inside. Used by the portal request thread.
 */
export default function ChatBubble({ own, name, nameExtra, time, timeDateTime, footerExtra, grouped = false, children, as: Tag = 'div' }: {
  own: boolean;
  name?: ReactNode;
  nameExtra?: ReactNode;
  time: string;
  timeDateTime?: string;
  footerExtra?: ReactNode;
  grouped?: boolean;
  children: ReactNode;
  as?: 'div' | 'li';
}) {
  return (
    <Tag className={`flex ${own ? 'justify-end' : 'justify-start'} ${grouped ? 'mt-0.5' : 'mt-3'}`}>
      <div className="max-w-[80%] md:max-w-[65%] min-w-0">
        {!grouped && (
          <div className={`flex items-center gap-2 mb-0.5 px-1 ${own ? 'justify-end' : 'justify-start'}`}>
            <span className="text-xs font-medium text-surface-700">{name}</span>
            {nameExtra}
          </div>
        )}
        <div className={`rounded-xl px-3 py-2 text-body-long ${bubbleSurface(own)}`}>
          {children}
          <div className={`flex items-center gap-2 mt-1 ${own ? 'justify-end' : 'justify-start'}`}>
            {footerExtra}
            <time dateTime={timeDateTime} className="text-xs text-surface-600 tabular-nums">{time}</time>
          </div>
        </div>
      </div>
    </Tag>
  );
}
